import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { projectFirestore } from "../firebase/config";
import React from "react";
import { Modal, Button } from 'react-bootstrap';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const Home = ({
  showModalOstudiu, handleCloseModalOstudiu,
  showModalPodminkyobjednani, handleCloseModalPodminkyobjednani,
  showModalKontakt, handleCloseModalKontakt,
  showModalTattoo, handleCloseModalTattoo,
  showModalPiercing, handleCloseModalPiercing,
  showModalMicrodermal, handleCloseModalMicrodermal,
  showModalGallery, handleCloseModalGallery

}) => {
    const [contentOstudiu, setContentOstudiu] = useState("");
    const [contentPodminkyObjednani, setContentPodminkyObjednani] = useState("");
    const [contentKontakt, setContentKontakt] = useState("");
    const [contentTattoo, setContentTattoo] = useState("");
    const [contentPiercing, setContentPiercing] = useState("");
    const [contentMicrodermal, setContentMicrodermal] = useState("");
    const [contentGallery, setContentGallery] = useState("");
    const [error, setError] = useState(false);

    Fancybox.bind('[data-fancybox="gallery"]', {});

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch 'ostudiu' content
                const contentOstudiuCollection = collection(projectFirestore, 'ostudiu');
                const snapshotOstudiu = await getDocs(contentOstudiuCollection);

                if (!snapshotOstudiu.empty) {
                    const docOstudiu = snapshotOstudiu.docs[0];
                    setContentOstudiu(docOstudiu.data().content);
                } else {
                    setError("No content found in 'ostudiu'");
                }

                // Fetch 'podminkyobjednani' content
                const contentPodminkyObjednaniCollection = collection(projectFirestore, 'podminkyobjednani');
                const snapshotPodminkyObjednani = await getDocs(contentPodminkyObjednaniCollection);

                if (!snapshotPodminkyObjednani.empty) {
                    const docPodminkyObjednani = snapshotPodminkyObjednani.docs[0];
                    setContentPodminkyObjednani(docPodminkyObjednani.data().content);
                } else {
                    setError("No content found in 'podminkyobjednani'");
                }

                // Fetch 'kontakt' content
                const contentKontaktCollection = collection(projectFirestore, 'kontakt');
                const snapshotKontakt = await getDocs(contentKontaktCollection);

                if (!snapshotKontakt.empty) {
                    const docKontakt = snapshotKontakt.docs[0];
                    setContentKontakt(docKontakt.data().content);
                } else {
                    setError("No content found in 'kontakt'");
                }

                // Fetch 'tatto' content
                const contentTattooCollection = collection(projectFirestore, 'tattoo');
                const snapshotTattoo = await getDocs(contentTattooCollection);

                if (!snapshotTattoo.empty) {
                    const docTattoo = snapshotTattoo.docs[0];
                    setContentTattoo(docTattoo.data().content);
                } else {
                    setError("No content found in 'tatto'");
                }

                // Fetch 'piercing' content
                const contentPiercingCollection = collection(projectFirestore, 'piercing');
                const snapshotPiercing = await getDocs(contentPiercingCollection);

                if (!snapshotPiercing.empty) {
                    const docPiercing = snapshotPiercing.docs[0];
                    setContentPiercing(docPiercing.data().content);
                } else {
                    setError("No content found in 'piercing'");
                }

                // Fetch 'microdermal' content
                const contentMicrodermalCollection = collection(projectFirestore, 'microdermal');
                const snapshotMicrodermal = await getDocs(contentMicrodermalCollection);

                if (!snapshotMicrodermal.empty) {
                    const docMicrodermal = snapshotMicrodermal.docs[0];
                    setContentMicrodermal(docMicrodermal.data().content);
                } else {
                    setError("No content found in 'microdermal'");
                }

                // Fetch 'gallery' content
                const contentGalleryCollection = collection(projectFirestore, 'images');
                const snapshotGallery = await getDocs(contentGalleryCollection);

                if (!snapshotGallery.empty) {
                    const images = snapshotGallery.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                    setContentGallery(images);
                } else {
                    setError("No content found in 'gallery'");
                }

            } catch (err) {
                setError(err.message);
                console.error("Error fetching data:", err);
            }
        };

        fetchData();
    }, []);

    return (
        <div>
            {error && <p>{error}</p>}

            <Modal show={showModalOstudiu} onHide={handleCloseModalOstudiu}>
                <Modal.Header>
                    <Button className="close" onClick={handleCloseModalOstudiu}></Button>
                </Modal.Header>
                <Modal.Body dangerouslySetInnerHTML={{ __html: contentOstudiu }}></Modal.Body>
            </Modal>
            <Modal show={showModalPodminkyobjednani} onHide={handleCloseModalPodminkyobjednani}>
                <Modal.Header>
                    <Button className="close" onClick={handleCloseModalPodminkyobjednani}></Button>
                </Modal.Header>
                <Modal.Body dangerouslySetInnerHTML={{ __html: contentPodminkyObjednani }}></Modal.Body>
            </Modal>
            <Modal show={showModalKontakt} onHide={handleCloseModalKontakt}>
                <Modal.Header>
                    <Button className="close" onClick={handleCloseModalKontakt}></Button>
                </Modal.Header>
                <Modal.Body dangerouslySetInnerHTML={{ __html: contentKontakt }}></Modal.Body>
            </Modal>
            <Modal show={showModalTattoo} onHide={handleCloseModalTattoo}>
                <Modal.Header>
                    <Button className="close" onClick={handleCloseModalTattoo}></Button>
                </Modal.Header>
                <Modal.Body dangerouslySetInnerHTML={{ __html: contentTattoo }}></Modal.Body>
            </Modal>
            <Modal show={showModalTattoo} onHide={handleCloseModalTattoo}>
                <Modal.Header>
                    <Button className="close" onClick={handleCloseModalTattoo}></Button>
                </Modal.Header>
                <Modal.Body dangerouslySetInnerHTML={{ __html: contentTattoo }}></Modal.Body>
            </Modal>
            <Modal show={showModalPiercing} onHide={handleCloseModalPiercing}>
                <Modal.Header>
                    <Button className="close" onClick={handleCloseModalPiercing}></Button>
                </Modal.Header>
                <Modal.Body dangerouslySetInnerHTML={{ __html: contentPiercing }}></Modal.Body>
            </Modal>
            <Modal show={showModalMicrodermal} onHide={handleCloseModalMicrodermal}>
                <Modal.Header>
                    <Button className="close" onClick={handleCloseModalMicrodermal}></Button>
                </Modal.Header>
                <Modal.Body dangerouslySetInnerHTML={{ __html: contentMicrodermal }}></Modal.Body>
            </Modal>
            <Modal show={showModalGallery} onHide={handleCloseModalGallery}>
                <Modal.Header>
                    <Button className="close" onClick={handleCloseModalGallery}></Button>
                </Modal.Header>
                <Modal.Body>
                    <h1>Galerie</h1>
                    <div className="gallery-list">
                    {contentGallery && contentGallery.map((image, index) => (
                        <a key={index} data-fancybox="gallery" href={image.originalUrl}>
                            <img
                                src={image.thumbnailUrl}
                                alt={image.alt || `Image ${index + 1}`}
                                style={{ width: "100%", marginBottom: "10px" }}
                                loading="lazy"
                            />
                        </a>
                        ))}
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default Home;
